import React, { useState, useEffect } from 'react';
import { Switch, Checkbox, Form, Input, Radio, Card, Divider, Steps, Select, Tag, Image, Row, Col, List, Avatar, DatePicker, Dropdown, Button, Menu, Typography, Space } from 'antd';
import './index.css';
import Navbar from '../../layouts/navbar';
import Footer from '../../layouts/footer';
import Slider from "react-slick";
import { InfoCircleOutlined, CalendarOutlined, CreditCardOutlined, SolutionOutlined, WifiOutlined, CheckCircleOutlined, CheckOutlined, EnvironmentOutlined, MessageOutlined, LikeOutlined, StarOutlined } from '@ant-design/icons';
import { AiOutlineWifi } from "react-icons/ai";
import { FaShower, FaSmokingBan } from "react-icons/fa";
import { RiWindyFill } from "react-icons/ri";
import Lottie from 'lottie-react-web';
import checkmark from '../../checkmark.json';
import failed from '../../failed.json';
import { mstAuth, mstBooking } from '../../mobx';
import { observer } from 'mobx-react-lite';
import { getSnapshot } from 'mobx-state-tree';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import BookingMenuSelection from '../../layouts/bookingMenuSelection';

const { Text, Link, Title } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Step } = Steps;
const { TextArea } = Input;

function totalDaysBetweenTwoDates (startDate, endDate) {
	let start = moment(startDate, "YYYY-MM-DD");
	let end = moment(endDate, "YYYY-MM-DD");

	return moment.duration(end.diff(start)).asDays();
};

const Booking = observer((props) => {
	const [currentStep, setCurrentStep] = useState(1)
	const [paymentStatus, setPaymentStatus] = useState("success")
	const [isLatest, setIsLatest] = useState(true)

	useEffect(() => {
		if (getSnapshot(mstAuth)?.user.UUID !== undefined) {
			mstBooking.fetchBookings({ UUID: getSnapshot(mstAuth)?.user?.UUID });
		}
	}, [getSnapshot(mstAuth)?.user.UUID !== undefined])

	const onSelectRoom = () => {
		setCurrentStep(2)
	};

	const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const listData = [];
	for (let i = 0; i < 15; i++) {
	  listData.push({
	    href: 'https://ant.design',
	    title: `Standard Room`,
	    avatar: 'https://joeschmoe.io/api/v1/random',
	    images: ['https://t-cf.bstatic.com/xdata/images/hotel/max1280x900/256747749.jpg?k=93c6c3dfbcf2a289169c0e201517a8b593836dda58609a97aca21df2c413b787&o=&hp=1', 'https://t-cf.bstatic.com/xdata/images/hotel/max1280x900/256694176.jpg?k=c20e3d5568b6639644d4d4d11692e4301a527e26a3b04387605610151cea022a&o=&hp=1', 'https://t-cf.bstatic.com/xdata/images/hotel/max1280x900/182473059.jpg?k=4311090e8d42e5c398327c917737069963c7f793fb5032d967eaad01aba5c45c&o=&hp=1', 'https://t-cf.bstatic.com/xdata/images/hotel/max1280x900/182473073.jpg?k=d9a5bf087a4f3967f33b2cc97ef497798a3ce7a40f8988aeb9faefc64e31371d&o=&hp=1'],
	    description:
	      '1 single bed  and 1 double bed',
	    amenities: ['Free Wi-fi', 'Shower', 'Non-Smoking', 'Air Conditioning', 'Hairdryer', 'Mini Fridge', 'LCD/LED Colour TV', 'Towels'],
	    benefits: ['Book without credit card', 'Pay at the hotel', 'Free Wi-Fi', 'Free cancellation before November 12, 2021'],
	    price: {
	    	originalPrice: 250,
	    	discountedPrice: 68
	    },
	    capacity: {
	    	adults: 4,
	    	childs: 2
	    }
	    // content: () => {
	    // 	return (
	    // 		<Text>Your price includes:</Text>
	    // 	)
	    // }
	  });
	}

	const data = [
	  {
	    title: '2 x Standard Room',
	  },
	  {
	    title: 'Ant Design Title 2',
	  },
	  {
	    title: 'Ant Design Title 3',
	  },
	  {
	    title: 'Ant Design Title 4',
	  },
	];

	const IconText = ({ icon, text, iconProps }) => (
	  <Space>
	    {React.createElement(icon, iconProps)}
	    {text}
	  </Space>
	);

	const renderOrderStatus = (status) => {
		console.log("check status ===> ", status)
		const label = status?.toLowerCase().charAt(0).toUpperCase() + status?.toLowerCase().slice(1);
		if (label === 'Payment successful') {
			return (<Tag className="bookingNumber" color="#87d068">Success</Tag>)
		} else if (label === 'Failed') {
			return (<Tag className="bookingNumber" color="#f50">Failed</Tag>)
		} else {
			return (<Tag className="bookingNumber" color="#2db7f5">{label}</Tag>)
		}
	};

	return (
		<div id="Booking">
			<div className="container">
			<Navbar hideBanner />
				<BookingMenuSelection />
	    <Footer />
	    </div>
		</div>
	)
});

export default Booking;